import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import { connect } from "react-redux";
import { mapStateToProps, mapDispatchToProps } from './impl/client-side-only-impl';

var ClientSideOnlyBase = /*#__PURE__*/function (_React$Component) {
  _inherits(ClientSideOnlyBase, _React$Component);

  var _super = /*#__PURE__*/_createSuper(ClientSideOnlyBase);

  function ClientSideOnlyBase() {
    _classCallCheck(this, ClientSideOnlyBase);

    return _super.apply(this, arguments);
  }

  _createClass(ClientSideOnlyBase, [{
    key: "render",
    value: function render() {
      if (this.props.clientSideRendered) {
        return /*#__PURE__*/React.createElement("div", {
          className: "client-side-only client-side-only-client"
        }, this.props.children);
      } else {
        return React.createElement(this.props.serverComponent || "div", Object.assign({
          className: "client-side-only client-side-only-server"
        }, this.props));
      }
    }
  }]);

  return ClientSideOnlyBase;
}(React.Component);
/**
 * This component will be loaded by client, and bypassed when doing server side rendering.
 *
 * Example
 * ```javascript
 * import { ClientSideOnly } from '@quintype/components';
 * <ClientSideOnly>
 *   This will be shown only on the client side
 * </ClientSideOnly>
 * ```
 * @see {@link WithClientSideOnly} for a render props version of this component
 * @component
 * @category Other
 */


export var ClientSideOnly = /*#__PURE__*/connect(mapStateToProps, mapDispatchToProps)(ClientSideOnlyBase);